<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
  >
    <v-btn slot="activator" flat fab small>
      <v-icon style="font-size: 2em;" color="primary">add</v-icon>
    </v-btn>
    <v-card>
      <v-list style="padding: 0">
        <v-list-tile @click="() => soups = !soups">
          <v-list-tile-action>
            <v-checkbox v-model="soups" color="primary" @click.stop="() => soups = !soups" />
          </v-list-tile-action>
          <v-list-tile-content>
            <span v-t="'editingContainer.soups'" />
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-text-field
              ref="focus"
              v-model="categoryName"
              :label="$t('editingContainer.categoryName')"
              :name="$t('editingContainer.categoryName')"
              :rules="[rules.required]"
              @keyup.enter="addCategory"
              @keydown.native.esc="menu = false"
            />
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>translate</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-text-field v-model="translation" :label="$t('editingContainer.translation')" @keyup.enter="addCategory" @keydown.native.esc="menu = false" />
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          hover
          flat
          color="primary"
          @click="addCategory"
        ><span v-t="'common.save'" /></v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import ValidationService from '@/services/ValidationService';
import NotificationService from '@/services/NotificationService';

export default {
  name: 'CategoryAddButton',
  data() {
    return {
      menu: null,
      categoryName: null,
      translation: null,
      soups: null,
      rules: {
        required: ValidationService.rules.required(),
      },
    };
  },
  watch: {
    menu(newValue) {
      if (newValue) {
        this.menu = true;
        this.translation = null;
        this.soups = false;
        this.$refs.focus.reset();
        this.focusInput();
      }
    },
  },
  methods: {
    focusInput() {
      setTimeout(() => {
        this.$refs.focus.focus();
      }, 100);
    },
    addCategory() {
      const categoryNameValid = ValidationService.validate(
        Object.keys(this.$refs)
          .filter(k => k === 'focus')
          .map(k => this.$refs[k]),
      );
      if (categoryNameValid) {
        this.$emit('addCategory', { name: this.categoryName, soups: this.soups, translation: this.translation });
        this.menu = false;
      } else {
        setTimeout(() => {
          const invalidFieldNames = [...new Set(ValidationService.getInvalidFieldNames())];
          NotificationService.showAlert({
            message: this.$t('common.invalidFields', { fields: invalidFieldNames.join(', ') }),
            level: 'error',
          });
        });
      }
    },
  },
};
</script>
<style scoped>
.v-list >>> .v-list__tile {
  height: 68px
}
</style>
